import { colors } from './biomeTokens';

export const colorTheme = {
  foundation: {
    100: colors.FOUNDATION_100,
    200: colors.FOUNDATION_200,
    300: colors.FOUNDATION_300,
    400: colors.FOUNDATION_400,
    500: colors.FOUNDATION_500
  },
  accent: {
    50: colors.ACCENT_50,
    100: colors.ACCENT_100,
    200: colors.ACCENT_200,
    300: colors.ACCENT_300
  },
  contrast: {
    lightest: colors.CONTRAST_LIGHTEST,
    darkest: colors.CONTRAST_DARKEST
  },
  text: {
    highEmphasis: colors.TEXT_HIGH_EMPHASIS,
    mediumEmphasis: colors.TEXT_MEDIUM_EMPHASIS,
    lowEmphasis: colors.TEXT_LOW_EMPHASIS,
    light: colors.CONTRAST_LIGHTEST,
    interactive: colors.ACCENT_200
  },
  stroke: {
    100: colors.FOUNDATION_100,
    200: colors.FOUNDATION_200,
    300: colors.FOUNDATION_400,
    400: colors.FOUNDATION_500
  },
  success: {
    300: colors.SUCCESS_300,
    500: colors.SUCCESS_500
  },
  warning: {
    300: colors.WARNING_300,
    500: colors.WARNING_500
  },
  alert: {
    300: colors.ALERT_300,
    500: colors.ALERT_500
  },
  progress: {
    300: colors.PROGRESS_300,
    500: colors.PROGRESS_500
  },
  structural: {
    0: colors.CONTRAST_LIGHTEST,
    50: colors.STRUCTURAL_50,
    100: colors.STRUCTURAL_100,
    200: colors.STRUCTURAL_200,
    300: colors.STRUCTURAL_300,
    400: colors.STRUCTURAL_400
  },
  chips: {
    grey: {
      50: colors.CHIPS_GREY_50,
      500: colors.CHIPS_GREY_500
    },
    brown: {
      50: colors.CHIPS_BROWN_50,
      500: colors.ACCENT_200
    },
    green: {
      50: colors.CHIPS_GREEN_50,
      500: colors.CHIPS_GREEN_500
    },
    yellow: {
      50: colors.CHIPS_YELLOW_50,
      500: colors.CHIPS_YELLOW_500
    },
    red: {
      50: colors.CHIPS_RED_50,
      500: colors.CHIPS_RED_500
    },
    blue: {
      50: colors.CHIPS_BLUE_50,
      500: colors.CHIPS_BLUE_500
    },
    teal: {
      50: colors.CHIPS_TEAL_50,
      500: colors.CHIPS_TEAL_500
    },
    plum: {
      50: colors.CHIPS_PLUM_50,
      500: colors.CHIPS_PLUM_500
    }
  },
  opacity: {
    secondary: colors.OPACITY_SECONDARY_10,
    primary: colors.OPACITY_PRIMARY_15
  },
  statusQueue: {
    healthy: '#5ba37a',
    atRisk: '#f6844e',
    critical: '#f24646',
    needsAttention: '#f6844e',
    superstar: '#bb529e'
  },
  dragHandle: '#8cb4c2',
  priorityBadge: {
    background: '#f0f2f4',
    text: '#45556e'
  }
};
